import { deleteCookie, getCookie, setCookie } from 'cookies-next/client';
import { validateRedirectUrl } from './usePostLogoutRedirect';

export const POST_CHECKOUT_SUCCESS_REDIRECT_COOKIE =
  'heidi-post-checkout-success-redirect';

export const setPostCheckoutSuccessRedirectCookie = (redirectUrl: string) => {
  setCookie(POST_CHECKOUT_SUCCESS_REDIRECT_COOKIE, redirectUrl, {
    path: '/',
    maxAge: 60 * 30,
    sameSite: 'lax',
    secure: window.location.protocol === 'https:',
  });
};

export const clearPostCheckoutSuccessRedirectCookie = () => {
  deleteCookie(POST_CHECKOUT_SUCCESS_REDIRECT_COOKIE);
};

export const consumePostCheckoutSuccessRedirectUrl = (): string | null => {
  const redirectUrl = getCookie(POST_CHECKOUT_SUCCESS_REDIRECT_COOKIE);

  if (redirectUrl && typeof redirectUrl === 'string' && redirectUrl.length > 0) {
    const validatedUrl = validateRedirectUrl(redirectUrl);
    clearPostCheckoutSuccessRedirectCookie();
    if (validatedUrl === '/' && redirectUrl !== '/') {
      return null;
    }
    return validatedUrl;
  }

  return null;
};
